export default {
  app: {
    error: {
      'field-invalid': 'This field contains invalid values',
      'field-required': 'This field is required',
      'email-spaces': 'The email cannot include leading and trailing spaces',
      'email-invalid': 'Email needs to be valid',
      'email-required': 'Please enter your email',
      'password-required': 'Please enter the password',
      'employee-id-invalid': 'This is not a valid employee ID',
      'employee-id-required':
        'Please enter the last four digits of your employee ID',
    },
  },
  back: 'Back',
};
